import { QuotaExceededError } from './custom-errors';
import { supabase } from './supabase.ts';

export async function processRagFile(
  fileId: string,
  content: string,
  chunkSize: number,
  chunkOverlap: number,
  embeddingModel: string,
  workspaceId: string,
) {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw new Error('User not authenticated');

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/process-rag-file`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'X-User-Token': session.access_token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fileId,
          content,
          chunkSize,
          chunkOverlap,
          embeddingModel,
          workspaceId,
        }),
      },
    );

    if (response.status === 429) {
      const body = await response.json().catch(() => ({}));
      throw new QuotaExceededError(body.error);
    }
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to process RAG file');
    }

    return response.json();
  } catch (error) {
    console.error('Error while processing RAG file:', error);
    throw error;
  }
}
